import { render } from "./tag.vue?vue&type=template&id=0c24aca8&scoped=true&ts=true"
import script from "./tag.vue?vue&type=script&lang=ts"
export * from "./tag.vue?vue&type=script&lang=ts"

import "./tag.vue?vue&type=style&index=0&id=0c24aca8&scoped=true&lang=css"

import exportComponent from "G:\\Coding_Projects\\cv2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c24aca8"]])

export default __exports__